import { CLIENT_LOGOS } from "@/data/clients";
import { SectionHead } from "./SectionHead";

const half = Math.ceil(CLIENT_LOGOS.length / 2);
const ROW_A = CLIENT_LOGOS.slice(0, half);
const ROW_B = CLIENT_LOGOS.slice(half);

const Logo = ({ logo, hidden }) => (
  <li className="grid h-24 w-24 shrink-0 place-items-center overflow-hidden rounded-xl border border-ink/10 bg-white p-2 sm:h-28 sm:w-28" aria-hidden={hidden || undefined}>
    <img src={logo.src} alt={hidden ? "" : logo.alt} width="256" height="256" loading="lazy" decoding="async" className="h-full w-full object-contain" />
  </li>
);

const Row = ({ logos, reverse }) => (
  <div className="relative overflow-hidden [mask-image:linear-gradient(90deg,transparent,#000_8%,#000_92%,transparent)]">
    <ul className={`flex w-max items-center gap-4 hover:[animation-play-state:paused] ${reverse ? "animate-marquee-reverse" : "animate-marquee"} [animation-duration:60s]`}>
      {[...logos, ...logos].map((l, i) => <Logo key={`${l.src}-${i}`} logo={l} hidden={i >= logos.length} />)}
    </ul>
  </div>
);

/** Auto-scrolling client logo slider (two rows moving in opposite directions). Static grid for reduced-motion users. */
export const LogoSlider = ({ eyebrow = "Trusted by businesses", title = "Brands We Have Built Digital Solutions For", intro, className = "" }) => (
  <section className={`py-16 md:py-24 ${className}`} data-testid="client-logos-section">
    <div className="container-x">
      <SectionHead eyebrow={eyebrow} title={title} intro={intro} />
    </div>
    <div className="mt-12 space-y-4 motion-reduce:hidden" data-testid="client-logo-slider">
      <Row logos={ROW_A} />
      <Row logos={ROW_B} reverse />
    </div>
    <ul className="container-x mt-12 hidden grid-cols-3 gap-3 sm:grid-cols-5 lg:grid-cols-8 motion-reduce:grid">
      {CLIENT_LOGOS.map((l) => <Logo key={l.src} logo={l} />)}
    </ul>
  </section>
);
